<template>
  <div id="floorplan-detail">
    <div class="close-icon" @click="close()">
      <img src="/img/cross-blue.png" alt="">
    </div>
    <div class="details-container">
      <div class="info-image-container">
        <div class="elevation">
          <img :src="floorplan.image.position" alt="Position">
        </div>
        <div class="layout">
          <img :src="floorplan.image.elevation" alt="Elevation">
        </div>
      </div>

      <div class="info-details-container">
        <div class="name">
          {{floorplan.name}}
          <span class="category" v-if=" floorplan['sub-category'] !='' ">
            {{ floorplan['sub-category'] }}
          </span>
        </div>
        <div class="details">
          <span class="sqft">{{Object.values(floorplan.sqft)[0].toLocaleString()}} SQ.FT.</span>
          <span class="room">{{floorplan.rooms.bed}} BEDROOMS</span>
          <span class="room">{{floorplan.rooms.bath}} BATHROOM</span>
          <span class="room">{{floorplan.rooms['powder room']}} POWDER ROOM</span>
        </div>
        <div class="floors">
          <span v-if="floorplan.floorplans.basement && floorplan.floorplans.basement !=='' ">
            <div class="level" >BASEMENT</div>
          </span>

          <div class="level" >GROUND FLOOR</div>
          <div class="level" >MAIN FLOOR</div>
          <div class="level" v-if="floorplan.floorplans.second && floorplan.floorplans.second !=='' "
            key="second">
            2ND FLOOR
          </div>
          <div class="level" v-if="floorplan.floorplans.third && floorplan.floorplans.third !=='' "
            key="third">
            3RD FLOOR
          </div>

          <span class="" v-if="floorplan.floorplans.thirdoptional && floorplan.floorplans.thirdoptional !=='' ">
            <div class="level"  key="third">
              3RD FLOOR <small>4 BED OPTION</small>
            </div>
            <!-- <div class="level" data-level="4" key="four">BASEMENT</div> -->
          </span>

        </div>
      </div>
      <div class="layout-container">
        <swiper :options="swiperOptionTop" class="gallery-top" @slideChange="slideChanged()" ref="swiperTop">
          <swiper-slide v-if="floorplan.floorplans.basement && floorplan.floorplans.basement !=='' ">
            <img :src="floorplan.floorplans.basement" alt="basement" />
          </swiper-slide>
          <swiper-slide>
            <img :src="floorplan.floorplans.ground" alt="ground" />
          </swiper-slide>
          <swiper-slide>
            <img :src="floorplan.floorplans.main" alt="main" />
          </swiper-slide>
          <swiper-slide v-if="floorplan.floorplans.second && floorplan.floorplans.second !='' ">
            <img :src="floorplan.floorplans.second" alt="second" />
          </swiper-slide>
          <swiper-slide v-if="floorplan.floorplans.third && floorplan.floorplans.third !='' ">
            <img :src="floorplan.floorplans.third" alt="third" />
          </swiper-slide>

          <swiper-slide v-if="floorplan.floorplans.thirdoptional && floorplan.floorplans.thirdoptional !=='' ">
            <img :src="floorplan.floorplans.thirdoptional" alt="basement" />
          </swiper-slide>

        </swiper>

      </div>

    </div>
  </div>
</template>

<script>
  import {
    Swiper,
    SwiperSlide,
    directive
  } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'

  export default {
    name: "floorplanDetail",
    props: ["floorplan"],
    data() {
      return {
        floorLevels: "",
        currentDetail: "",
        swiperOptionTop: {
          spaceBetween: 10,
          slidesPerView: 1,
          loop: false,
          effect: 'flip',
          fadeEffect: {
            crossFade: true
          },
        },

      }
    },
    components: {
      Swiper,
      SwiperSlide
    }, //components
    directives: {
      swiper: directive
    }, //directives
    mounted() {
      this.floorLevels = document.querySelectorAll(".info-details-container .floors .level");
      console.log("the floors are ", this.floorLevels);

      this.floorLevels.forEach((element, index) => {
        element.dataset.level = index;
        if (index == 0) {
          element.classList.add('active');
        }
        element.addEventListener('click', (e) => {
          this.changeLevel(e);
        });
      });

    }, //mounted
    methods: {
      changeLevel(e) {
        let activeLevel = e.target.dataset.level;
        this.slideChanged(activeLevel);
      },
      close() {
        this.$emit('close');
      },
      slideChanged(slide) {
        let slideNum = slide || this.$refs.swiperTop.$swiper.realIndex;
        this.$refs.swiperTop.$swiper.slideToLoop(+slideNum, 300);
        this.floorLevels.forEach(elem => {
          if (elem.dataset.level == slideNum) {
            elem.classList.add("active");
          } else {
            elem.classList.remove("active");
          }
        });
      }
    }

  }
</script>
<style lang="scss" scoped>
  #floorplan-detail {
    width: 100%;
    height: 100%;
    background: white;
    top: 0;
    left: 0;
    position: absolute;
  }

  .details-container {
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;

    .info-image-container {
      flex: 0 1 360px;
      max-width: 360px;

      .elevation {
        height: 140px;
        width: 100%;
      }

      .layout {
        height: calc(100% - 140px);

      }
    }

    .info-details-container {
      flex: 0 1 455px;
      width: 355px;
      padding: 130px 50px 50px 50px;
      text-align: left;
      text-transform: uppercase;

      span {
        display: block;
        padding: 5px 0;
        font-size: 24px;
        font-family: 'EngraversGothicW01-Bold';
        color: black;
      }

      .name {
        color: #0071CE;
        font-size: 70px;
        font-family: 'EngraversGothicBTW01-Re';
        white-space: nowrap;

        padding: 0 0 10px 0;

        .category {
          color: #0071CE;
          font-size: 30px;
          line-height: 1;
          letter-spacing: 0.1em;
          padding: 0px 0 0 0;
          display: block;
          width: 100%;
        }
      }

      .floors {
        padding-top: 70px;

        .level {
          font-family: 'EngraversGothicBTW01-Re';
          color: #B5B5B5;
          font-size: 30px;
          text-transform: uppercase;
          letter-spacing: 0;
          padding: 8px 0;
          white-space: nowrap;

          small {
            font-size: 24px;
          }

          &.active {
            color: black;
          }
        }
      }
    }

    .layout-container {
      flex: 0 1 1105px;
      max-width: 1205px;
      width: 1205px;
      padding: 40px 10px 40px 100px;
    }

  }

  .swiper-wrapper {
    width: 100% !important;

    .swiper-slide {
      width: 100%;
      max-width: 100%;
      text-align: left;

      img {
        max-width: 100%;
        max-height: 912px;
      }
    }
  }

  .close-icon {
    position: absolute;
    top: 0px;
    right: 20px;
    padding: 30px;
    z-index: 9;
  }
</style>